// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__gRlpc","title":"header_title__3WX8L"};